import { useState, useEffect } from 'react';
import M_LanguageSwitcher from '../../components/M_Molecules/M_LanguageSwitcher/M_LanguageSwitcher';
import W_SignContainer from '@/components/W_Wrappers/W_SignContainer/W_SignContainer';
import A_Notification from '@/components/A_Atoms/A_Notification/A_Notification';
import styles from './AuthPage.module.css';
import cn from 'classnames';
import AuthImage from '@/assets/images/A_ScreenSaver.png';

export default function AuthPage() {
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  useEffect(() => {
    if (error) {
      setErrorMessage(error);
    }
  }, [error]);

  useEffect(() => {
    if (success) {
      setSuccessMessage(success);
    }
  }, [success]);

  return (
    <div className={styles.page}>
      <div className={styles.action_wrapper}>
        <M_LanguageSwitcher />
        <W_SignContainer onError={setError} onSuccess={setSuccess} />
      </div>
      <div className={styles.image_wrapper}>
        <div className={styles.round_decorator}></div>
        <img
          src={AuthImage}
          alt='Карусель с фотографиями'
          className={styles.auth_image}
        />
        <span className={cn(styles.copyright_text, 'text-p-6')}>
          2026 © Timecaps
        </span>
      </div>
      {errorMessage && (
        <A_Notification
          type='error'
          message={errorMessage}
          isVisible={!!error}
          onClose={() => {
            setError(null);
            setTimeout(() => setErrorMessage(null), 350);
          }}
        />
      )}
      {successMessage && (
        <A_Notification
          type='success'
          message={successMessage}
          isVisible={!!success}
          onClose={() => {
            setSuccess(null);
            setTimeout(() => setSuccessMessage(null), 350);
          }}
        />
      )}
    </div>
  );
}
